<template>
    <div class="container"
         role="progressbar"
         :aria-valuenow="activeStep"
         :aria-valuemin="0"
         :aria-valuemax="steps.length">
        <div class="step-title-container vcore_hidden--sm--down">
            <div v-for="(step, i) in steps"
                 v-bind:key="step"
                 :class="{ active: i === activeStep, completed: i < activeStep }"
                 :aria-disabled="i !== activeStep ? 'true' : 'false'">
                {{ step }}
            </div>
        </div>
        <div class="progress-bar-container">
            <span class="progress-bar"
                  :style="{
          'background-position': barWidth + '%'
        }"></span>
            <div v-for="(step, i) in steps"
                 v-bind:key="step"
                 class="step"
                 :class="{ active: i === activeStep && !hasError, completed: i < activeStep && !hasError, error: i === activeStep && hasError }">
                <span class="marker"></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProgressBar",
        props: {
            steps: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            activeStep: {
                type: Number,
                default: 0
            },
            hasError: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            barWidth() {
                let width = (this.activeStep / (1 - this.steps.length)) * 100;

                return width >= -100 ? width : -100;
            }
        }
    };
</script>

<style lang="scss" scoped>
    $step-diameter: 15px;
    $active-step-diameter: 23px;
    $progress-bar-height: 15px;

    .container {
        width: 100%;
        position: relative;

        @media (max-width: $grid-breakpoint-sm) {
            width: 95%;
            margin: 0 auto;
        }

        & > div

    {
        display: flex;
    }

    .step-title-container {
        margin-bottom: 13px;
        & > div

    {
        flex-grow: 2;
        flex-basis: 0;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        font-weight: bold;
        font-family: "Open Sans";
        -webkit-transition: opacity 0.5s;
        -moz-transition: opacity 0.5s;
        transition: opacity 0.5s;
        color: rgba(0, 107, 143);
        opacity: 0.6;
        &:first-of-type

    {
        text-align: left;
        flex-grow: 1;
    }

    &:last-of-type {
        text-align: right;
        flex-grow: 1;
    }

    &.active {
        color: rgba(0, 107, 143);
        opacity: 1;
    }

    }
    }

    .progress-bar-container {
        height: $progress-bar-height;
        &.progress-bar-container-error

    {
        .progress-bar

    {
        background-image: none;
        background-color: $color_red;
    }

    .step {
        .marker

    {
        height: $progress-bar-height;
        width: $progress-bar-height;
        border: none;
        background-color: $color_red;
    }

    }
    }
    }

    .progress-bar {
        width: calc(100% - #{$step-diameter});
        height: $progress-bar-height;
        position: absolute;
        left: $step-diameter / 2;
        background-size: 200% 100%;
        background-image: linear-gradient(to right, #9bdaeb 50%, #006b8f 50%);
        -webkit-transition: background-position .8s;
        -moz-transition: background-position .8s;
        transition: background-position .8s;
        z-index: -1;
    }

    .step {
        flex-grow: 1;
        flex-basis: 0;
        position: relative;
        
    .marker
    {
        width: $step-diameter;
        height: $step-diameter;
        content: "";
        line-height: $step-diameter;
        border: 2px solid #006b8f;
        display: block;
        position: absolute;
        right: $step-diameter / -2;
        top: ($progress-bar-height - $step-diameter) / 2;
        border-radius: 50%;
        margin: 0 auto;
        background-color: white;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        transition: all 0.5s;
    }

    // Move Marker to left for step 1
    &:first-of-type {
        position: absolute;
        .marker

    {
        left: 0;
    }

    &.active,
    &.completed,
    &.error {
        .marker

    {
        left: $active-step-diameter / -4;
    }

    }
    }

    // Adjust first and last bar
    &:nth-of-type(2),
    &:last-of-type {
        &::after

    {
        width: calc(100% - #{$step-diameter / 2});
        left: $step-diameter / 2;
    }

    }

    &:last-of-type {
        .marker

    {
        right: 0;
    }

    &.active,
    &.completed,
    &.error {
        .marker

    {
        right: $active-step-diameter / -4;
    }

    }

    &::after {
        left: 0;
    }

    }

    // Active step
    &.active,
    &.completed,
    &.error {
        .marker

    {
        width: $active-step-diameter;
        height: $active-step-diameter;
        border: 2px solid #006b8f;
        top: ($progress-bar-height - $active-step-diameter) / 2;
        background-color: white;
        right: $active-step-diameter / -2;
        &::before

    {
        border-radius: 50%;
        position: absolute;
        content: "";
        width: 50%;
        height: 50%;
        background-color: #006b8f;
        left: 25%;
        top: 25%;
    }

    }
    }

    &.completed {
        .marker

    {
        background-color: #006b8f;
        &::after

    {
        content: url("~@Shared/assets/images/check.svg");
        padding: 1px 3px;
        display: block;
    }

    &::before {
        content: none;
    }

    }
    }

    &.error {
        .marker

    {
        background-color: $color_red;
        border-color: $color_red;
        &::after

    {
        content: url("~@Shared/assets/images/exclaimation.svg");
        padding: 2px 8px;
        display: block;
    }

    &::before {
        content: none;
    }

    }
    }
    }
    }
</style>
